import "./Link.scss";
import "../../../styles/typography.scss";
import { clsx } from "clsx";
import { ElementType } from "react";

type Props = {
  title: string;
  src: string;
  decoration?: string;
  transform?: "uppercase" | "lowercase" | "capitalize" | "none";
  icon?: ElementType;
  asLink?: ElementType;
  external?: boolean;
};

export function Link({
  title,
  src,
  decoration = "",
  transform = "none",
  icon: Icon,
  asLink = "a",
  external = false,
}: Props) {
  const LinkTag = asLink || "a";

  return (
    <LinkTag
      className={clsx(
        "link link-sans-bold-sm",
        decoration,
        `text-${transform}`,
      )}
      href={src}
      target={external ? "_blank" : ""}
      rel={external ? "noopener noreferrer" : ""}
    >
      {title}
      {Icon && <Icon class={"link-icon"} size="md" />}
    </LinkTag>
  );
}
